import React, { useCallback } from "react";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";
import { ColorItemType } from "@mapmycustomers/shared/types/map/PinLegend";
import { ColorDropdown } from "@mapmycustomers/ui";

import OptionValueEditorProps from "../types/OptionValueEditorProps";

import BaseOptionItem from "./BaseOptionItem";

interface Props<T> extends OptionValueEditorProps<T> {}

const ColorOptionItem = <T extends ColorItemType>({ label, onChange, value }: Props<T>) => {
  const handleColorChange = useCallback(
    (color: AnyColor) => {
      onChange?.({ ...value, color });
    },
    [onChange, value]
  );

  return (
    <BaseOptionItem label={label}>
      <ColorDropdown
        colorPanelProps={{ showColorSpace: true, showInput: true, showNamedColors: true }}
        onChange={handleColorChange}
        value={value.color}
      />
    </BaseOptionItem>
  );
};

export default ColorOptionItem;
